export default "__VITE_ASSET__U_KJC6rO__"